import React, { useState } from 'react'
import { Box } from '@chakra-ui/react'
import CandidatesTable from '../../../components/tables/CandidatesTable'
import InterviewsTable from '../../../components/tables/InterviewsTable'
import PipelineBoard from '../../../components/recruitment/PipelineBoard'
import ReportsDashboard from '../../../components/recruitment/ReportsDashboard'
import VacancyTable from '../../../components/tables/VacancyTable'
import VacancyOverview from '../../../components/recruitment/VacancyOverview'
import InflowTable from '../../../components/tables/InflowTable'

interface RecruitmentPageProps {
  selectedTab: string
}

const RecruitmentPage: React.FC<RecruitmentPageProps> = ({ selectedTab }) => {
  const [isScrolled, setIsScrolled] = useState(false)

  const renderContent = () => {
    switch (selectedTab) {
      case 'candidates':
        return <CandidatesTable />
      case 'pipeline':
        return <PipelineBoard />
      case 'interviews':
        return <InterviewsTable />
      case 'reports':
        return <ReportsDashboard />
      case 'vacancy':
        return <VacancyTable/>
      case 'overview':
        return <VacancyOverview />
      case 'inflow':
        return <InflowTable />
      default:
        return <CandidatesTable />
      
    }
  }

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Box
      h="100%"
      w="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      {renderContent()}
    </Box>
  )
}

export default RecruitmentPage
